export enum IntegrationType {
  QUICKBOOKS_ONLINE = "QUICKBOOKS_ONLINE",
  QUICKBOOKS_DESKTOP = "QUICKBOOKS_DESKTOP",
  QUICKBOOKS_DESKTOP_ITEMS = "QUICKBOOKS_DESKTOP_ITEMS",
  PLAID_EXTERNAL_CARD_ACCOUNT = "PLAID_EXTERNAL_CARD_ACCOUNT",
  ASTRADA_EXTERNAL_CARD_ACCOUNT = "ASTRADA_EXTERNAL_CARD_ACCOUNT",
  ASTRADA_CONNECTION = "ASTRADA_CONNECTION",
  ASTRADA_BANK_CONNECTION = "ASTRADA_BANK_CONNECTION",
}
